// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"9c324eaf83a10131","741":"f276f5017855a4d5"}[chunkId] + ".js";
};